<template>
  <div class="home">
    <div class="row">
      <div class="col">
        <form>
          <LayoutVariator qsKey="variation" class="orderPage">
            <FormSection title="Account Details" id="accountSection">
              <AccountDetails v-model="newCustomer"></AccountDetails>
            </FormSection>
            <FormSection title="Your Menu" id="menuSection">
              <BasketList></BasketList>
            </FormSection>
            <FormSection title="Delivery Details" id="deliverySection">
              <DeliveryDetails v-model="delivery"></DeliveryDetails>
            </FormSection>
            <FormSection title="Add A Voucher" id="voucherSection">
              <ApplyVoucher
                :button-label="!hasVoucher ? 'Apply' : 'Remove'"
                place-holder="enter your code"
              ></ApplyVoucher>
            </FormSection>
            <FormSection title="Complete Your Order" id="orderSection">
              <BasketValue></BasketValue>
            </FormSection>
            <div class="row">
              <div class="col"></div>
            </div>
          </LayoutVariator>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import BasketList from "@/components/cart/BasketList.vue";
import BasketValue from "@/components/cart/BasketValue";
import ApplyVoucher from "@/components/cart/ApplyVoucher";
import AccountDetails from "@/components/cart/AccountDetails";
import DeliveryDetails from "@/components/cart/DeliveryDetails";

import FormSection from "@/components/form/FormSection";

import LayoutVariator from "@/components/ui/LayoutVariator";

import { basketBase } from "@/components/cart/basketBase";

import { mapGetters, mapState } from "vuex";

export default {
  name: "home",
  components: {
    BasketList,
    BasketValue,
    ApplyVoucher,
    AccountDetails,
    DeliveryDetails,
    FormSection,
    LayoutVariator
  },
  mixins: [basketBase],
  computed: {
    ...mapState({
      hasVoucher: state => state.basket.hasVoucher,
      newCustomer: state => state.basket.customer,
      delivery: state => state.basket.delivery
    })
  }
};
</script>
